export default defineNuxtPlugin( () => {
    const router = useRouter()
    const { hideComponent } = useComponentVisibility( "trial-dialog" )

    router.beforeEach( ( _to, _from, next ) => {
      hideComponent()
      next() // Call `next()` to proceed with the navigation
    } )
  } )
